import React, { PureComponent } from 'react';
import classnames from 'classnames';
import _range from 'lodash.range';
import { Flex } from 'reflexbox';

class BlockVis extends PureComponent {
  render() {
    const { seats, align, style, className } = this.props;
    const visClasses = classnames('seat-wrapper', className);
    const size = Math.ceil(Math.sqrt(seats));
    const wrapperJustify = align === 'left' ? 'flex-start' : 'flex-end';
    let count = 0;

    return (
      <Flex column wrap className={visClasses}>
        {_range(size).map(ri => (
          <Flex className="seat-row" key={`SeatRow_${className}_${ri}`} justify={wrapperJustify}>
            {_range(size).map(ci => {
              const seat = count < seats ? <div key={`Seat_${className}_${ci}`} style={style} className="seat" /> : null;
              count++;
              return seat;
            })}
          </Flex>
        ))}
      </Flex>
    );
  }
}

class SeatVis extends PureComponent {
  render() {
    const { seats, align, color, cutout } = this.props;
    const showCutout = !!(cutout && cutout > 0);

    return (
      <div className="seatvis">
        <BlockVis
          className="seatvis__normal"
          seats={seats}
          style={{ background: color }}
          align={align}
        />
        {showCutout && (
          <BlockVis
            className="seatvis__cutout"
            style={{ border: `1px solid ${color}`, background: 'rgba(255,255,255,0.7)' }}
            seats={cutout}
            align={align}
          />
        )}
      </div>
    );
  }
}

export default SeatVis;
